/** tax/taxApi.ts — 세무사 사이트 공개 API (backend routes/tax.js) · 로그인 없음 */
export interface TaxMonth { ym: string; n_programs: number; n_issues: number; updated_at: string }
export interface TaxProgram { id: string; k: string; o: string; n: string; a: string; w: string; d: string; x: string; deadline: string; nationwide: boolean; local?: string; link: string }
export interface TaxIssue { id: string; kind: string; label: string; caption: string; title: string; body: string; action: string; star: boolean }
export interface TaxMonthData { ym: string; published: boolean; programs: TaxProgram[]; issues: TaxIssue[] }
export interface TaxCfg {
  office: string; role: string; person: string; tel: string; mob: string; logo: string; color: string;
  sido: string; sigungu: string; industry: string; sizes: string[]; program_ids: string[]; issue_id: string;
}

async function j<T>(path: string, init?: RequestInit): Promise<T> {
  const r = await fetch('/api/tax' + path, { ...init, headers: { 'Content-Type': 'application/json', ...(init && init.headers) } });
  const b = await r.json().catch(() => null) as { success?: boolean; data?: T; error?: string } | null;
  if (!r.ok || !b || !b.success) throw new Error((b && b.error) || '잠시 뒤에 다시 시도해 주세요');
  return b.data as T;
}

export const getMonths = () => j<TaxMonth[]>('/newsletter/months');
export const getMonth = (ym: string, cond: { sido: string; sigungu?: string; industry: string; sizes: string[] }) =>
  j<TaxMonthData>(`/newsletter/${ym}?sido=${encodeURIComponent(cond.sido)}&sigungu=${encodeURIComponent(cond.sigungu || '')}&industry=${encodeURIComponent(cond.industry)}&sizes=${encodeURIComponent(cond.sizes.join(','))}`);
export const getPreview = (ym: string, cfg: TaxCfg) => j<{ html: string; file: string }>('/newsletter/preview', { method: 'POST', body: JSON.stringify({ ym, cfg }) });

/** 파일 받기 → { blob, name } */
export async function getFile(ym: string, cfg: TaxCfg, kind: 'pdf' | 'jpg'): Promise<{ blob: Blob; name: string }> {
  const r = await fetch('/api/tax/newsletter/file', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ym, cfg, kind }) });
  if (!r.ok) {
    const b = await r.json().catch(() => null) as { error?: string } | null;
    throw new Error((b && b.error) || '파일을 만들지 못했습니다');
  }
  const cd = r.headers.get('Content-Disposition') || '';
  const m = /filename\*=UTF-8''([^;]+)/.exec(cd);
  const name = m ? decodeURIComponent(m[1]) : `소식지.${kind}`;
  return { blob: await r.blob(), name };
}

export const OFFICE_KEY = 'roumTax.office';

// ── 이 브라우저에 기억(사무소 정보 · 받는 고객 조건) — 저장소가 막혀도 화면은 그대로 동작 ──
export function load<T>(key: string, fallback: T): T {
  try { const v = window.localStorage.getItem(key); return v ? { ...fallback, ...JSON.parse(v) } : fallback; } catch (e) { return fallback; }
}
/** 이 기기에 저장한 값 지우기 — 여러 사무소가 같은 컴퓨터를 쓸 때(2026-10-09 지도사 「다른 사람 것이 보이면 안 돼」) */
export function forget(key: string): void {
  try { window.localStorage.removeItem(key); } catch (e) { /* 막힘 — 무시 */ }
}
export function save(key: string, v: unknown): void {
  try { window.localStorage.setItem(key, JSON.stringify(v)); } catch (e) { /* 저장소 막힘 — 이번 화면에서만 */ }
}
